import type { UserProfileDto } from '../../../domain/contracts/api.contracts';
import { useTranslation } from '../../../application/hooks/useTranslation';
import { Card } from '../ui/Card';

/** W04 — registered payout account (masked), read-only. */
export function LinkedPaymentCard({ payout }: { payout: UserProfileDto['payout'] }) {
  const { t } = useTranslation();
  return (
    <Card title={t('profile.payout')}>
      {payout ? (
        <dl className="kv" data-testid="payout-card">
          <dt>{t('profile.payoutMethod')}</dt>
          <dd>{payout.method === 'BKASH' ? 'bKash' : t('profile.payoutBank')}</dd>
          <dt>{t('profile.payoutAccount')}</dt>
          <dd className="tabular">{payout.accountMasked}</dd>
          <dt>{t('profile.payoutHolder')}</dt>
          <dd>{payout.holderName}</dd>
        </dl>
      ) : (
        <p className="muted" data-testid="payout-empty">
          {t('profile.notOnRecord')}
        </p>
      )}
    </Card>
  );
}
